import React from 'react'
import { MessageSquare } from 'lucide-react'
import { Avatar, AvatarImage } from '@/components/ui/avatar'
import { cn } from '@/lib/utils'
import Timeago from '../timeago'

const STATE_LABELS = [
  ['priority', 'Priority'],
  ['in_placement', 'Placement'],
  ['tutor_selected', 'Tutor selected'],
  ['tutor_selection_feedback', 'Selection feedback'],
  ['deactivated', 'Deactivated'],
  ['lesson_order_preferences', 'Lesson Order'],
  ['paid', 'Paid'],
  ['converted', 'Converted'],
]

class BacklogItemsPartial extends React.Component {

  constructor(props) {
    super(props)

    this.onClick = this.onClick.bind(this)
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick(this.props.item)
    }
  }

  render() {
    const item = this.props.item

    const labels = STATE_LABELS
      .filter(([state]) => item.states.includes(state))
      .map(([, label]) => label)

    return (
      <button
        type="button"
        onClick={this.onClick}
        className={cn(
          'flex w-full items-center gap-3 rounded-2xl p-3 text-left transition-colors ring-1',
          this.props.selected
            ? 'bg-foreground/10 ring-foreground/30'
            : 'ring-foreground/10 hover:bg-foreground/5'
        )}
      >
        <Avatar size="lg">
          <AvatarImage src={item.image} alt={item.name} />
        </Avatar>
        <div className="flex min-w-0 flex-1 flex-col gap-0.5">
          <div className="truncate text-sm font-medium leading-tight">{item.name}</div>
          {item.states.includes('international') ?
            <div className="truncate text-xs text-muted-foreground">{item.country}</div>
            : null
          }
          <div className="text-xs text-muted-foreground">
            <Timeago date={item.time} />
          </div>
          {item.next_task ?
            <div className="truncate text-xs text-muted-foreground">{item.next_task.name}</div>
            : null
          }
          {labels.length > 0 ?
            <div className="mt-1 flex flex-wrap gap-1">
              {labels.map((label) => (
                <span
                  key={label}
                  className={cn(
                    'rounded px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide',
                    label === 'Priority'
                      ? 'bg-info text-info-foreground'
                      : 'bg-foreground/15 text-foreground/80'
                  )}
                >
                  {label}
                </span>
              ))}
            </div>
            : null
          }
        </div>
        {item.states.includes('has_messages') ?
          <MessageSquare className="size-4 shrink-0 text-muted-foreground" />
          : null
        }
      </button>
    )
  }
}

export default BacklogItemsPartial
